import React, { useEffect, useState } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import ShareButtons from "../components/ShareLinks"
import { Seo } from "../components/Seo"
import { useLocation } from "@reach/router"
import { PortableText } from "@portabletext/react"
import urlBuilder from "@sanity/image-url"
import ExploreLink from "../components/ExploreLink"
import useDeviceCheck from "../deviceCheck"
import InitKoalendar from "../components/init-koalendar"
const ComponentName = ({
  data: {
    caseStudies: {
      csTitle,
      csImage,
      visitSiteUrl,
      csLogoImage,
      categoryTag,
      description,
      metaTitle,
      image,
      csSlug,
      _rawContent: json,
    },
    allSanityCaseStudies,
  },
}) => {
  const cnt = json

  const isTablet = useDeviceCheck("tablet")
  const isMobile = useDeviceCheck("mobile")
  const pathLocation = useLocation()

  const url = pathLocation.href
  // const url= typeof window !== "undefined" ? window.location.href : "";
  //const url= "https://sogody.com";

  const SampleImageComponent = ({ value, isInline }) => {
    if (!value?.asset) {
      console.warn("Missing or invalid image asset:", value)
      return null
    }
    return (
      <img
        src={urlBuilder({ projectId: "3hfxs7a8", dataset: "production" })
          .image(value)
          .url()}
        alt={"Update image banner"}
        className="update-cnt-image my-3"
        loading="lazy"
        style={{
          // Display alongside text if image appears inside a block text span
          display: isInline ? "inline-block" : "block",

          // Avoid jumping around with aspect-ratio CSS property
        }}
      />
    )
  }
  const SampleVideoComponent = ({ value, isInline }) => {
    if (!value?.video?.asset?.fileURL) {
      console.warn("Missing or invalid video asset:", value)
      return null
    }
    return (
      <div
        className="video-container"
        style={{
          display: isInline ? "inline-block" : "block",
          margin: "20px 0",
        }}
      >
        <video
          src={value.video.asset.fileURL}
          playsInline
          loop
          autoPlay
          muted
          className="portable-text-video"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "8px",
          }}
        >
          Your browser does not support the video tag.
        </video>
      </div>
    )
  }
  console.log("data", cnt)
  const myPortableTextComponents = {
    block: {
      normal: ({ children }) => <p className="up-paragraph">{children}</p>,
      h1: ({ children }) => <h1 className="heading1">{children}</h1>,
      h2: ({ children }) => <h2 className="heading2">{children}</h2>,
      h3: ({ children }) => <h3 className="heading3">{children}</h3>,
      h4: ({ children }) => <h4 className="heading4">{children}</h4>,
      h5: ({ children }) => <h5 className="heading5">{children}</h5>,
      h6: ({ children }) => <h6 className="heading6">{children}</h6>,
    },

    types: {
      image: SampleImageComponent,
      cardVideoR2: SampleVideoComponent,
    },

    list: {
      bullet: ({ children }) => <ul className="ul-list">{children}</ul>,
      number: ({ children }) => <ol className="ol-list">{children}</ol>,
      checkmarks: ({ children }) => (
        <ol className="m-auto text-lg">{children}</ol>
      ),
    },

    listItem: {
      bullet: ({ children, value: { style } }) => (
        <li>
          {style === "normal" ? (
            <p className="up-paragraph">{children}</p>
          ) : (
            children
          )}
        </li>
      ),
    },

    marks: {
      link: ({ children, value }) => {
        const rel = !value?.href?.startsWith("/")
          ? "noreferrer noopener"
          : undefined
        return (
          <a href={value.href} rel={rel}>
            {children}
          </a>
        )
      },
    },
  }

  const [nextUpdate, setNextUpdate] = useState(null)
  console.log(visitSiteUrl)
  useEffect(() => {
    const filteredUpdates = allSanityCaseStudies.nodes.filter(
      update => update.csSlug !== csSlug
    )
    if (filteredUpdates.length > 0) {
      const randomUpdate =
        filteredUpdates[Math.floor(Math.random() * filteredUpdates.length)]
      setNextUpdate(randomUpdate)
    }
  }, [allSanityCaseStudies, csSlug])
  return (
    <div className="single-sog-up">
      <Layout hideFooter={true}>
        <Seo
          title={metaTitle}
          description={description[0].children[0].text}
          image={csImage?.asset?.url}
          url={url}
        />

        <div className="up-container single-update-container">
          <div className="inner-update-container">
            {isTablet && (
              <div>
                {categoryTag && categoryTag.length > 0 && (
                  <span className="d-flex mobile-category-tag">
                    {categoryTag.slice(0, 2).map(tag => (
                      <span
                        key={tag._id}
                        className="category-tag subtitle pb-0 mt-0"
                      >
                        {tag.tag}
                      </span>
                    ))}
                  </span>
                )}
                <h1 className="title pt-2 mb-4 justify-content-start text-left h2-styling">
                  {csTitle}
                </h1>
              </div>
            )}
            <div className="d-flex main-content-container justify-content-center">
              <div className="updates-images">
                <div
                  className="cs-logo sticky-image mb-3"
                  style={{ backgroundImage: `url(${csImage.asset?.url})` }}
                ></div>
                {!isMobile && !isTablet && (
                  <div className="d-flex" style={{ gap: "10px" }}>
                    {visitSiteUrl && (
                      <div
                        className="next-update-card case-study-card d-flex flex-column justify-content-between p-3"
                        style={{ flex: 1 }}
                      >
                        <img
                          className="next-img"
                          src={csLogoImage?.asset?.url || csImage?.asset?.url}
                          alt="Current Update"
                        />
                        <div className="explore-link-div explore-link-case-studies">
                          <ExploreLink
                            text="Visit Site"
                            href={visitSiteUrl}
                            openInNewTab
                          />
                        </div>
                      </div>
                    )}

                    {nextUpdate && (
                      <div
                        className="next-update-card case-study-card d-flex flex-column justify-content-between p-3"
                        style={{ flex: 1 }}
                      >
                        <img
                          className="next-img"
                          src={
                            nextUpdate.csLogoImage?.asset?.url ||
                            nextUpdate.csImage?.asset?.url
                          }
                          alt="Next Update"
                        />
                        <div className="explore-link-div explore-link-case-studies">
                          <ExploreLink
                            text="Next Project"
                            to={`/work/${nextUpdate.csSlug}`}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="single-up-content scrollable-text">
                {!isTablet && (
                  <div>
                    {categoryTag && categoryTag.length > 0 && (
                      <span className="d-flex">
                        {categoryTag.slice(0, 2).map(tag => (
                          <span
                            key={tag._id}
                            className="category-tag subtitle pb-0 mt-0"
                          >
                            {tag.tag}
                          </span>
                        ))}
                      </span>
                    )}
                    <h1 className="title pt-2 mb-4 justify-content-start h2-styling">
                      {csTitle}
                    </h1>
                  </div>
                )}
                <div className="single-update">
                  <PortableText
                    value={cnt}
                    components={myPortableTextComponents}
                  />
                  <h2 className="heading2">Not there yet?</h2>
                  <p className="subtitle">
                    Unsure with your needs? or if you have any questions, book a
                    call with us. we’d be happy to explore how we can create a
                    plan that fits you perfectly.
                  </p>
                </div>
                <div className="share-article d-flex">
                  <InitKoalendar
                    showButton={true}
                    blackButton={true}
                    className="contact-us-link button-padding"
                    buttonText="Hire us"
                    href="/contact"
                  ></InitKoalendar>
                  <ShareButtons
                    url={url ? url : " "}
                    title={csTitle}
                    summary={csTitle}
                    body={`${csTitle}\n\n Visit: ${url}\n`}
                  />
                </div>
              </div>
              {(isMobile || isTablet) && (
                <div className="d-flex mt-3" style={{ gap: "10px" }}>
                  {visitSiteUrl && (
                    <div
                      className="next-update-card case-study-card d-flex flex-column justify-content-between p-3"
                      style={{ flex: 1 }}
                    >
                      <img
                        className="next-img"
                        src={csLogoImage?.asset?.url || csImage?.asset?.url}
                        alt="Current Update"
                      />
                      <div className="explore-link-div explore-link-case-studies">
                        <ExploreLink
                          text="Visit Site"
                          href={visitSiteUrl}
                          openInNewTab
                        />
                      </div>
                    </div>
                  )}

                  {nextUpdate && (
                    <div
                      className="next-update-card case-study-card d-flex flex-column justify-content-between p-3"
                      style={{ flex: 1 }}
                    >
                      <img
                        className="next-img"
                        src={
                          nextUpdate.csLogoImage?.asset?.url ||
                          nextUpdate.csImage?.asset?.url
                        }
                        alt="Next Update"
                      />
                      <div className="explore-link-div explore-link-case-studies">
                        <ExploreLink
                          text="Next Project"
                          to={`/work/${nextUpdate.csSlug}`}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </Layout>
    </div>
  )
}

export const query = graphql`
  query GetSingleCaseStudy($slug: String) {
    caseStudies: sanityCaseStudies(csSlug: { eq: $slug }) {
      _rawContent(resolveReferences: { maxDepth: 10 })
      csTitle
      csSlug
      visitSiteUrl
      categoryTag {
        tag
      }
      csLogoImage {
        asset {
          url
        }
      }
      csImage {
        asset {
          url
        }
      }
      _createdAt(formatString: "D MMMM YYYY")
      description {
        children {
          text
        }
        }
      metaTitle
      image {
        asset {
          url
        }
      }
    }
    allSanityCaseStudies(sort: { fields: _createdAt, order: DESC }) {
      nodes {
        id
        csSlug
        csTitle
        bannerVideoR2 {
          asset {
            fileURL
          }
        }
        csImage {
          asset {
            url
          }
        }
        csLogoImage {
          asset {
            url
          }
        }
        categoryTag {
          _id
          tag
        }
      }
    }
  }
`

export default ComponentName
